import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';
import PlantShoppingList from '../components/PlantShoppingList';
import GardenShoppingList from '../components/GardenShoppingList';
import PreviewSVG from '../components/PreviewSVG';
import { Stack, Title, Text, Box, Divider, Grid, ActionIcon } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';

const PrintableSummary = () => {
	const { state } = useAppContext();
	const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

	const {
		designName,
		zone,
		style,
		sunlight,
		windows,
		facade,
		houseSize,
		shape,
		bedSize,
		chosenPlants,
	} = state.currentDesign;

	useEffect(() => {
		if (isLoading) return;

		// Trigger print on page load
		window.print();

		// Redirect to dashboard after printing
		const handleAfterPrint = () => navigate('/');

		window.onafterprint = handleAfterPrint;

		// Cleanup event listener
		return () => {
			window.onafterprint = null;
		};
	}, [navigate, isLoading]);

	return (
		<>
			<style>
				{`
					@media print {
						.no-print {
							display: none !important;
						}
					}
					.back-button {
						position: absolute;
						top: 16px;
						left: 16px;
						background-color: rgba(0, 0, 0, 0.05);
						transition: all 0.2s ease;
					}
					.back-button:hover {
						background-color: rgba(0, 0, 0, 0.25) !important;
						transform: scale(1.05);
					}
				`}
			</style>
			<Box p="md" mx="auto" className="printable-summary">
				<ActionIcon 
					variant="light" 
					size="xl" 
					radius="xl"
					onClick={() => navigate('/')}
					className="no-print"
					sx={{
						position: 'absolute',
						top: 16,
						left: 16,
						backgroundColor: 'rgba(0, 0, 0, 0.03)',
						transition: 'all 0.2s ease',
						'&:hover': {
							backgroundColor: 'rgba(0, 0, 0, 0.35)',
							transform: 'scale(1.1)'
						}
					}}
				>
					<IconArrowLeft size={24} color="#333333" />
				</ActionIcon>
				<Box mb="md" style={{ width: '100%' }}>
					<Box style={{ overflowX: 'auto', width: '100%', display: 'flex', justifyContent: 'center' }}>
						<Box style={{ minWidth: '1500px' }}>
							<PreviewSVG setIsLoading={setIsLoading}/>
						</Box>
					</Box>
				</Box>
				<Stack spacing={4} align="center" mb="lg">
					<Title order={1} align="left">Design: {designName}</Title>
					<Grid gutter="md" style={{ width: '100%', maxWidth: 600 }}>
						<Grid.Col span={6} style={{ textAlign: 'left' }}>
							<Text size="md">Growing Zone: {zone}</Text>
							<Text size="md">Garden Style: {style}</Text>
							<Text size="md">Amount of Sunlight: {sunlight}</Text>
							<Text size="md">Number of Windows: {windows}</Text>
						</Grid.Col>
						<Grid.Col span={6} style={{ textAlign: 'left' }}>
							<Text size="md">Garden Background: {facade}</Text>
							<Text size="md">Size of House: {houseSize}</Text>
							<Text size="md">Garden Bed Shape: {shape}</Text>
							<Text size="md">Garden Bed Size: {bedSize}</Text>
						</Grid.Col>
					</Grid>
				</Stack>
				<Divider my="md" />
				<Stack spacing="xl" align="stretch">
					<Box>
						<Title order={3} mb="xs" align="center">Your Chosen Plants</Title>
						<Box style={{ maxWidth: 900, width: '100%', margin: '0 auto' }}>
							<PlantShoppingList plants={chosenPlants} />
						</Box>
					</Box>
					<Box>
						<Title order={3} mb="xs" align="center">Additional Recommended Materials</Title>
						<Box style={{ maxWidth: 900, width: '100%', margin: '0 auto' }}>
							<GardenShoppingList />
						</Box>
					</Box>
				</Stack>
			</Box>
		</>
	);
};

export default PrintableSummary;
